import React from 'react';

import { CsvIcon } from '~/assets';
import { FileCheckIcon } from '~/assets/FileChooser';

import { FileName, SentFileCardContainer } from './ComposerAttachment.styles';

interface SentFileCardProps {
  fileName: string;
}

/** A file sent with a user message, shown by name only, live and in history. */
const SentFileCard = ({ fileName }: SentFileCardProps): JSX.Element => (
  <SentFileCardContainer>
    <CsvIcon />
    <FileName title={fileName}>{fileName}</FileName>
    <FileCheckIcon />
  </SentFileCardContainer>
);

export default SentFileCard;
